import React from 'react';
import { Box, Heading, Text, Alert, VStack, useColorModeValue } from '@chakra-ui/react';

const Icd10ModifiersGuideline = () => {
  const sectionBg = useColorModeValue('gray.50', 'gray.700');

  return (
    <Box maxW="900px">
      <Heading as="h1" size="xl" mb={6} color="brand.700">
        ICD-10-CM Optional Modifiers
      </Heading>

      <Text fontSize="lg" mb={8} color="gray.600">
        This section outlines the guidelines and best practices for applying optional modifiers in ICD-10-CM coding, specifically tailored for Surgical Assist scenarios.
      </Text>

      <VStack spacing={8} align="stretch">
        
        <Box>
          <Heading as="h2" size="lg" mb={4} color="brand.800">
            Overview of Optional Modifiers
          </Heading>
          <Text mb={4}>
            While many modifiers are strictly required for billing compliance (such as laterality or NCCI bypass modifiers), there are specific scenarios where optional modifiers can provide additional clinical context without impacting claim adjudication.
          </Text>
          <Alert status="info" variant="left-accent" bg={sectionBg} borderColor="brand.500">
            <Box>
              <Text fontWeight="bold" mb={2}>Key Principle:</Text>
              <Text>
                Optional modifiers should only be applied when they directly support the medical necessity of the procedure performed, and when the documentation explicitly supports their use.
              </Text>
            </Box>
          </Alert>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4} color="brand.800">
            Common Surgical Assist Scenarios
          </Heading>
          <Text mb={4}>
            In the context of Surgical Assist, optional modifiers are most frequently encountered in complex orthopedic or neurological procedures where the primary surgeon's documentation may lack the granularity required for highly specific ICD-10-CM codes.
          </Text>
          <Text>
            <em>(Note: Specific modifier mappings and examples will be populated here as the MPH onboarding team finalizes the payer-specific rules engine).</em>
          </Text>
        </Box>

      </VStack>
    </Box>
  );
};

export default Icd10ModifiersGuideline;